import React, {useEffect, useState, Fragment} from 'react';
import {Spinner} from "react-bootstrap";
import {connect} from "react-redux";

import PrintService from "../../services/PrintService";

const printPanelStyle={
    "marginRight": "43px",
    "marginLeft": "13px"
}


const PrintPanel = (props) => {

    const [capture, setCapture] = useState()
    const [format, setFormat] = useState('a4')
    const [resolution, setResolution] = useState(150)
    const [scale, setScale] = useState('5')
    const [scaleFactorX, setScaleFactorX] = useState(30)
    const [scaleFactorY, setScaleFactorY] = useState(30)
    const [scaleTop, setScaleTop] = useState(45)
    const printService = new PrintService(props.mapref)

    useEffect(()=>{
        setCapture(props.printScreenCapt)
    }, [props.printScreenCapt])

    useEffect(()=>{
        //console.log('print ',props.printState);
        //
        // (props.printState)?printService.printMap(props.mapref, format, resolution, scale):null

    }, [props.printState])

    const handleOnClick=()=>{
        //console.log(format,resolution,scale)
        printService.printMap(props.mapref, format, resolution, scale)
    }

    const handleScaleChange= (e)=>{
        setScale(e.target.value)
    }

    useEffect(()=>{
        switch(scale){
            case '5':
                setScaleFactorY(99)
                setScaleFactorX(99)
                setScaleTop((296-(296*0.99))/2)
                break
            case '4':
                setScaleFactorY(78)
                setScaleFactorX(78)
                setScaleTop((296-(296*0.78))/2)
                break
            case '3':
                setScaleFactorY(70)
                setScaleFactorX(70)
                setScaleTop((296-(296*0.70))/2)
                break
            case '2.5':
                setScaleFactorY(59/1.19)
                setScaleFactorX(59)
                setScaleTop((296-(296*0.55))/2)
                break
            case '2':
                setScaleFactorY(55/1.19)
                setScaleFactorX(55)
                setScaleTop((296-(296*0.48))/2)
                break
            case '1':
                setScaleFactorY(22)
                setScaleFactorX(22)
                setScaleTop((296-(296*0.22))/2)
                break
        }
    }, [scale])

    return (
        <div className={'card'} style={printPanelStyle}>
            <div className="card-body text-center" style={{"overflow": "hidden"}}>

                <div  className={"eu-screen-capture text-center"}>
                    {
                        (capture)
                        ?<Fragment>
                            <img
                                src={props.printScreenCapt}
                                alt={'visualisation impression'}
                            />
                            <div id={'eu-scale-factor'} className={'eu-scale-factor'} style={{"top":scaleTop+"px", "width": scaleFactorX+"%", "height": scaleFactorY+"%"}}></div>
                         </Fragment>
                        :<div className="text-center my-2"><Spinner animation="border" size={'md'}/></div>
                    }

                </div>
                <div className={'ue-print-form'}>
                        <div className="row mt-3">
                            <div className="col-12 col-md-6">
                                <label htmlFor={'format'}>Format </label>
                                <select id="format" className={'form-control'} onChange={(e)=> setFormat(e.target.value)} value={format}>
                                    <option value="a3">A3</option>
                                    <option value="a4" >A4</option>
                                    <option value="a5">A5</option>
                                </select>
                            </div>
                            <div className="col-12 col-md-6">
                                <label htmlFor={'resolution'}>Résolution </label>
                                <select id="resolution" className={'form-control'} onChange={(e)=> setResolution(e.target.value)} value={resolution}>
                                    <option value="72">72 dpi</option>
                                    <option value="150">150 dpi</option>
                                    <option value="200" >200 dpi</option>
                                </select>
                            </div>
                            <div className="col-12 mt-3">
                                <label htmlFor={'sale'}>Echelle </label>
                                <select id="scale" className={'form-control'} onChange={handleScaleChange} value={scale}>
                                    <option value="5">1:5000</option>
                                    <option value="4">1:4000</option>
                                    <option value="3">1:3000</option>
                                    <option value="2.5">1:2500</option>
                                    <option value="2">1:2000</option>
                                    <option value="1">1:1000</option>
                                </select>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <button className={'btn btn-primary btn-block mt-2'}  onClick={handleOnClick}>Imprimer</button>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
};


const mapStateToProps = state => {
    return {
        printState : state.PrintReducer.printState,
    }
}

const mapDispatchTProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(PrintPanel);
